import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { auth, db } from "./auth/UsersConfig/Authfirebase";
import { getDoc, doc } from "firebase/firestore";

// CSS Imports
import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'draft-js/dist/Draft.css';
import "./StyleBase/base.css";

// Component Imports
import Header from "./HeaderFooter/Header";
import Footer from "./HeaderFooter/Footer";
import Login from "./auth/Login";
import Register from "./auth/Register";
import Reset from "./auth/Reset";
import Home from './Home';
import Dashboard from "./System/Dashboard";
import UserContext, { useUserContext } from './auth/UserContext';
import ProgressLoad from "./Tools/ProgressLoad";
import Products from "./System/Products";

import DetalleProducto from "./Cliente/DetalleProducto";
import Catalogo from "./Catalogos/Catalogo";
import VerxCategoria from "./Cliente/VerxCategoria";
import Inventario from "./System/Inventario";
import EditProduct from "./System/EditProduct";

import { CartProvider } from "./auth/UsersConfig/CartContext";
import Pedidos from "./System/Pedidos";
function App() {
  const [CurrentUser, setCurrentUser] = useState(null);
  const [progrLoading, setProgrLoading] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) {
        UserDetail(user.uid);
      } else {
        setCurrentUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const UserDetail = async (uid) => {
    setProgrLoading(true);
    try {
      const myUser = doc(db, "Users", uid);
      const querySnapshot = await getDoc(myUser);

      if (querySnapshot.exists()) {
        setCurrentUser(querySnapshot.data());
      } else {
        console.log("No se encontró ningún documento con el uid proporcionado");
      }
    } catch (err) {
      console.error("Error al obtener datos del usuario", err);
    } finally {
      HideLoading();
    }
  };

  const HideLoading = () => {
    setTimeout(() => { setProgrLoading(false) }, 1000);
  };

  return (
    <Router>
      <div className="App">
        <UserContext.Provider value={{ CurrentUser }}>
          <CartProvider>
            <Header /> {/* encabezado del sistema */}
            <div className="BodyApp">
              <Routes>
                <Route exact path="/" element={<Home />} />
                <Route exact path="/Login" element={<Login />} />
                <Route exact path="/register" element={<Register />} />
                <Route exact path="/reset" element={<Reset />} />
                <Route exact path="/Home" element={<Home />} />
                <Route exact path="/dashboard" element={CurrentUser === null ? <Home /> : <Dashboard />} />
                <Route exact path="/Products" element={CurrentUser === null ? <Home /> : <Products />} />
                <Route exact path="/Inventario" element={CurrentUser === null ? <Home /> : <Inventario />} />
                <Route path="/DetalleProducto/:IdDoc" element={<DetalleProducto />} />
                <Route exact path="/Catalogo" element={CurrentUser === null ? <Home /> : <Catalogo />} />
                <Route exact path="/VerCat/:IdCat" element={<VerxCategoria />} />
                <Route exact path="/editarPr/:id" element={<EditProduct />} />
                <Route exact path="/pedidos" element={<Pedidos />} />
              </Routes>
            </div>
            <Footer />
          </CartProvider>
        </UserContext.Provider>
        {progrLoading && <ProgressLoad />}
      </div>
    </Router>
  );
}

export default App;
